module.exports = __webpack_public_path__ + "img/filter.b57335c5.svg";